










































import { Component, Prop, Vue } from "vue-property-decorator";
import { PraesidiumQuestionCategory } from "@/api/models/PraesidiumQuestionCategory";
import { PraesidiumQuestion } from "@/api/models/PraesidiumQuestion";
import { PraesidiumQuestionAnswer } from "@/api/models/PraesidiumQuestionAnswer";
import { UserPraesidiumEntry } from "@/api/models/UserPraesidiumEntry";
import PraesidiumCardQuestionsAnswer from "@/components/praesidium/PraesidiumCardQuestionsAnswer.vue";
import { Optional } from "@/types/Optional";

@Component({
    components: { PraesidiumCardQuestionsAnswer }
})
export default class PraesidiumCardQuestions extends Vue {
    /**
     * Praesidium entry to display.
     */
    @Prop()
    praesidiumEntry: UserPraesidiumEntry;

    /**
     * Category position to display.
     */
    @Prop()
    categoryLocation: "card" | "left" | "right";

    /**
     * Get a list with all the available question categories.
     */
    get categories(): Array<PraesidiumQuestionCategory> {
        return (
            require("@/api/content/praesidium/praesidium_questions_categories.json")
                // Only add the categories with questions that have been answered.
                .filter((category: PraesidiumQuestionCategory) =>
                    this.getQuestions(category).find(question => this.getAnswer(question))
                )

                // Only add the categories that have the correct position.
                .filter((category: PraesidiumQuestionCategory) => category.location === this.categoryLocation)

                // Sort based on order.
                .sort((category: PraesidiumQuestionCategory) => category.order)
        );
    }

    /**
     * Get a list with all available questions.
     */
    get questions(): Array<PraesidiumQuestion> {
        return require("@/api/content/praesidium/praesidium_questions.json");
    }

    /**
     * Get a list with questions for a given category.
     */
    getQuestions(category: PraesidiumQuestionCategory): Array<PraesidiumQuestion> {
        return this.questions.filter(question => category.questions.includes(question.id));
    }

    /**
     * Get the answer for a given question, provided by the user.
     * Can be undefined when the answer is unavailable.
     */
    getAnswer(question: PraesidiumQuestion): Optional<PraesidiumQuestionAnswer> {
        return this.praesidiumEntry.questions.find(answer => answer.id === question.id);
    }
}
